import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ClaimModalComponent } from 'projects/visa-platform/src/app/shared/components/claim-modal/claim-modal.component';
import { FooterComponent } from 'projects/visa-platform/src/app/shared/components/footer/footer.component';
import { HeaderComponent } from 'projects/visa-platform/src/app/shared/components/header/header.component';
import { LanguageService } from 'projects/visa-platform/src/app/shared/services/language.service';
import { RazorpayAnalyticsService } from 'projects/visa-platform/src/app/shared/services/razorpay-analytics.service';
import { environment } from 'projects/visa-platform/src/environments/environment';

@Component({
  selector: 'visa-platform-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ClaimModalComponent,
    ToastModule,
  ],
  templateUrl: './app.component.html',
  providers: [MessageService],
})
export class AppComponent implements OnInit {
  public constructor(
    private titleService: Title,
    private analyticsService: RazorpayAnalyticsService,
    private languageService: LanguageService,
    private meta: Meta
  ) {
    this.titleService.setTitle(environment?.projectTitle);
    if (environment.razorAnalyticsFlag) {
      this.analyticsService.init();
    }
  }

  public ngOnInit(): void {
    this.loadGoogleAnalytics(environment?.gTagTrackingId);
    if (environment.showLanguageDropdown) {
      this.languageService.setLanguageTexts();
    }
    if (!environment.production) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }
  }

  private loadGoogleAnalytics(trackingID: string): void {
    if (environment.production) {
      const gaScript = document.createElement('script');
      gaScript.setAttribute('async', 'true');
      gaScript.setAttribute(
        'src',
        `https://www.googletagmanager.com/gtm.js?id=${trackingID}`
      );
      const gaScript2 = document.createElement('script');
      // eslint-disable-next-line no-useless-escape
      gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

      document?.documentElement?.firstChild?.appendChild(gaScript);
      document?.documentElement?.firstChild?.appendChild(gaScript2);
    }
  }
}
